import { tt } from "../i18n/tt";
import { guideUrl } from "./guideLinks";
// 상시 도움말(GuideHint) 문구 원장 — 기획 docs/ops/kakao-archive-tooltip-tutorial-plan.md §2–§3 (2026-09-20, 대표 결정 ⓐ).
//
// 라벨 옆 ⓘ 하나가 답인 반복 문의를 모은다. 문장은 이용 가이드(docs.laeebly.io)와 **같은 문장**을 쓴다 —
// 가이드가 바뀌면 여기도 같이 바꾼다(안내 3종 동기화 규칙 2026-09-15).
//
// - id 규칙: `<영역>.<요지>` — channel.* · inspect.* · work.* · promo.* · settle.* · revenue.* · billing.*(멤버십·결제 → c-plan)
// - 문구는 전부 getter 다(guideFlow.js 와 같은 이유): 모듈 로드 시점에 tt() 를 굳히면 첫 화면 언어로 고정된다.
// - i18n 키는 원문 md5 앞 8자(`a.<md5>`) — scripts/i18n/codemod.js 규칙과 같다. `node scripts/i18n/catalog.js` 가 긁어 간다.
// - 대표 결정에 걸린 문구(초대 권한·검수 URL 필수 여부·지오블락 나라 목록·(g) 표기·정산 첨부 서류)는 넣지 않는다.
//   inspect.url 은 URL 필수 여부를 말하지 않고, inspect.geoblock 은 유튜브 메뉴 경로만 말한다.
// - 2026-09-24 쿠팡 직계약·형식 코드(docs/ops/coupang-direct-format-code-plan.md §9): work.format-choice / work.code-format / work.code-anatomy /
//   work.no-inspection / work.whitelist-provided / channel.tiktok-link / channel.instagram-link / channel.offsite-no-whitelist — 문구는 §9 표 그대로.
//   work.* 인데 c-upload(식별코드)·c-inspect(검수) 로 여는 것은 §9 표의 지정이다(테스트 예외 목록과 같다).

/** 도움말이 가리킬 수 있는 가이드 문서 slug — 여기 없는 slug 는 테스트가 막는다 */
export const GUIDE_HINT_SLUGS = ["c-channel", "c-onboard", "c-inspect", "c-works", "c-promo", "c-settle", "c-revenue", "c-upload", "c-plan", "c-bundle"];

export const GUIDE_HINTS = {
  // 2026-09-24 구글 연결 — 동의 한 장 → 연습 화면(필수) → 구글. 문장은 c-channel 「구글로 넘어가기 전에 연습 화면」 문단과 같은 뜻으로 유지한다.
  "channel.google-connect": {
    get title() { return tt("a.60f5b589", "구글 계정으로 연결"); },
    get body() { return tt("a.db0d5c85", "동의 한 장 → 연습 화면(체크 칸 3개 체크, 필수) → 구글 화면에서 같은 체크 칸 3개 체크 → 돌아와 등록. 인증코드는 필요 없어요. 뷰어 초대와 원화(KRW) 설정은 구글로 연결해도 필요해요. 연결한 채널마다 등급 가점 +1."); },
    guideSlug: "c-channel",
    get askLay() { return tt("a.d40def36", "구글 계정으로 채널을 연결하면 무엇이 달라지나요?"); },
  },
  "channel.google-practice": {
    get title() { return tt("a.e8d7f240", "구글 화면 연습"); },
    get body() { return tt("a.4e079cfc", "구글 화면에 「선택하세요」라고 써 있어도 체크 칸 3개는 전부 필수입니다. 여기서 체크 칸 3개를 체크해 본 뒤 구글에서도 같은 자리를 체크하세요."); },
    guideSlug: "c-channel",
    get askLay() { return tt("a.6ee99aa5", "구글 화면에서 체크 칸 3개를 모두 체크해야 하나요?"); },
  },
  "channel.google-revoke": {
    get title() { return tt("a.bf1b52ab", "연결 해제 신청"); },
    get body() { return tt("a.cd172f1f", "정산은 이 채널의 스튜디오 수익 지표를 받아야 끝나서, 해제는 신청 뒤 운영팀이 정산 자료 확인을 마치고 처리해요. 다른 구글 계정으로 바꾸려면 해제 없이 다시 연결하면 돼요."); },
    guideSlug: "c-channel",
    get askLay() { return tt("a.1ed6608b", "구글 연결 해제는 왜 바로 안 되나요?"); },
  },
  "channel.type": {
    get title() { return tt("a.653a3e1c", "채널 유형"); },
    get body() { return tt("a.dd5da790", "직접 운영하는 채널은 「일반 채널」을 고르세요. 오리지널·브랜드·슈퍼 채널은 레이블리가 배정합니다."); },
    guideSlug: "c-channel",
    get askLay() { return tt("a.c7310417", "채널 유형은 어떤 걸 골라야 하나요?"); },
  },
  "channel.verify-code": {
    get title() { return tt("a.de358eee", "인증코드"); },
    get body() { return tt("a.c0257499", "채널 실소유 확인용 코드입니다. 인증이 끝나면 설명란에서 지워도 됩니다. 영상에 넣는 식별코드와는 다릅니다."); },
    guideSlug: "c-channel",
    get askLay() { return tt("a.95fdef74", "채널 인증코드는 인증 뒤에 지워도 되나요?"); },
  },
  "channel.invite-mail": {
    get title() { return tt("a.3e400810", "초대 메일"); },
    get body() { return tt("a.50219fd9", "초대 메일이 안 오면 주소를 직접 입력해 다시 보내 주세요. 붙여넣기 할 때 빈칸이 섞이지 않았는지 확인하세요."); },
    guideSlug: "c-onboard",
    get askLay() { return tt("a.cf011ca4", "스튜디오 초대 메일이 안 와요."); },
  },
  "channel.pending": {
    get title() { return tt("a.9aa6a1ac", "승인 대기"); },
    get body() { return tt("a.0de76f05", "승인 전에는 작품·검수 신청의 채널 목록에 나오지 않습니다."); },
    guideSlug: "c-channel",
    get askLay() { return tt("a.5b9d39c9", "채널이 승인 대기 중이면 작품 신청을 못 하나요?"); },
  },
  "channel.kakao-partner-only": {
    get title() { return tt("a.525b5e11", "제휴된 사용자만"); },
    get body() { return tt("a.c5c9d830", "오류가 아니라 카카오 승인 시차입니다. 승인되면 열립니다."); },
    guideSlug: "c-channel",
    get askLay() { return tt("a.ebfc0752", "카카오 스튜디오에 「제휴된 사용자만」이라고 떠요."); },
  },
  // ── 틱톡·인스타그램 채널 (2026-09-24 대표 결정 ④ B · ③ 100% 크리에이터 + 보정 ㈗ 「정책 마련 시 같은 배분율」 반드시 안내 — 기획 §9 표 문구 그대로)
  "channel.tiktok-link": {
    get title() { return tt("a.58394d78", "틱톡 프로필 주소"); },
    get body() { return tt("a.4fd38a8e", "프로필 주소를 https://www.tiktok.com/@아이디 형식으로 넣어 주세요. 앱에서 프로필 → 공유 → 링크 복사로 얻을 수 있어요."); },
    guideSlug: "c-channel",
    get askLay() { return tt("a.bb5487e1", "틱톡 채널 주소는 어떻게 넣나요?"); },
  },
  "channel.instagram-link": {
    get title() { return tt("a.618f4e41", "인스타그램 프로필 주소"); },
    get body() { return tt("a.9ac16c17", "프로필 주소를 https://www.instagram.com/아이디/ 형식으로 넣어 주세요. 앱에서 프로필 → 공유 → 링크 복사로 얻을 수 있어요."); },
    guideSlug: "c-channel",
    get askLay() { return tt("a.22f274fb", "인스타그램 채널 주소는 어떻게 넣나요?"); },
  },
  "channel.offsite-no-whitelist": {
    // 🔒 「지금은 전부 크리에이터 몫 … 정책이 마련되면 같은 배분율」 줄은 대표 보정 ㈗ — 빼지 않는다
    get title() { return tt("a.2f778261", "틱톡·인스타그램 안내"); },
    get body() { return tt("a.30b5658c", "틱톡·인스타그램에는 화이트리스트가 없어요. 등록해 두면 문제가 생겼을 때 레이블리가 공문 등으로 도와요. 수익은 지금은 전부 크리에이터 몫이지만 수익 쉐어 정책이 마련되면 다른 플랫폼과 같은 배분율이 적용돼요(적용 전 안내). 식별코드를 넣지 않거나 가이드라인을 어기면 이용 권한이 제공되지 않아요."); },
    guideSlug: "c-channel",
    get askLay() { return tt("a.67d6ba40", "틱톡·인스타그램 채널은 화이트리스트와 수익이 어떻게 되나요?"); },
  },
  "channel.shorts-count": {
    get title() { return tt("a.9f93bd34", "제작한 쇼츠"); },
    get body() { return tt("a.7a855693", "3분 이하 영상을 세는 집계 기준이에요. 만들 때 권장하는 길이(60초)와는 달라요."); },
    guideSlug: "c-upload",
    get askLay() { return tt("a.25241714", "제작한 쇼츠 수는 어떻게 세나요?"); },
  },
  "inspect.url": {
    get title() { return tt("a.2248a6fa", "유튜브 영상 URL"); },
    get body() { return tt("a.8fe33dc4", "유튜브에 「일부 공개」로 올린 주소를 넣으세요. 전체 공개로 올리면 안 됩니다."); },
    guideSlug: "c-inspect",
    get askLay() { return tt("a.6d2287e6", "검수 신청할 때 영상은 어떻게 올려야 하나요?"); },
  },
  "inspect.episode": {
    get title() { return tt("a.690a32b1", "회차·영상 번호"); },
    get body() { return tt("a.71d67db3", "영화는 회차를 1로 고정하고 영상 번호만 순서대로 붙입니다."); },
    guideSlug: "c-inspect",
    get askLay() { return tt("a.37d832d7", "영화는 회차와 영상 번호를 어떻게 적나요?"); },
  },
  "inspect.blocked": {
    // 2026-09-14 하이브리드: 스위치 → 차단 신고. 2026-09-21: 행마다 붙던 「유튜브에서 차단됐어요」 버튼 → 승인 칸 머리 안내 띠(BlockReportStrip)의 제목 옆
    get title() { return tt("a.blk.hint.title", "유튜브 차단 알리기"); },
    // 2026-09-23 수정판: 한 흐름(채널 → 작품 → 막힌 영상 주소 → 종류)으로 검수 여부와 상관없이 알린다
    get body() { return tt("a.blk.hint.body3", "공개한 영상이 유튜브에서 저작권 차단·클레임에 걸렸을 때 씁니다. 검수를 받았든 안 받았든 채널·작품을 고르고 막힌 영상 주소를 넣으면 돼요. 권리사가 확인하면 알림이 옵니다. 지오블락(특정 지역 차단)은 신고가 아닙니다."); },
    guideSlug: "c-inspect",
    get askLay() { return tt("a.blk.hint.ask", "승인된 영상이 유튜브에서 차단되면 어떻게 하나요?"); },
  },
  "inspect.selfcheck": {
    // 2026-10-02 직접 점검 구조 — 신청 창 체크 줄 머리의 ⓘ. 유튜브 자동 확인이 아니라 내가 보고 체크하는 것임을 짧게
    get title() { return tt("a.insp.hint.self.title", "직접 점검"); },
    get body() { return tt("a.insp.hint.self.body", "유튜브 스튜디오에서 공개 상태·지오블락·식별코드를 직접 보고 체크해요. 체크하면 바로 권리사에게 가고, 레이블리가 신청 뒤 유튜브와 대조해 다르면 알려 드려요. 권리사 승인은 따로 알림이 와요."); },
    guideSlug: "c-inspect",
    get askLay() { return tt("a.insp.hint.self.ask", "검수 신청 때 직접 점검은 무엇을 보고 체크하나요?"); },
  },
  "inspect.geoblock": {
    get title() { return tt("a.6ef1220e", "지오블락 확인"); },
    get body() { return tt("a.62f416d7", "유튜브 스튜디오 › 권리 관리 › 소유권 › 특정 지역 › 「소유권 외 지역 동영상 차단」에서 설정합니다. PC 업로드 때만 설정할 수 있습니다."); },
    guideSlug: "c-inspect",
    get askLay() { return tt("a.3453c296", "지오블락은 유튜브에서 어떻게 거나요?"); },
  },
  "inspect.status-pending": {
    get title() { return tt("a.insp.group.waiting2", "검수 중"); }, // 2026-10-06 「권리사가 보는 중」→「검수 중」
    get body() { return tt("a.79308e30", "여기 보이면 접수된 것입니다. 목록에 안 보이면 다시 신청해 주세요."); },
    guideSlug: "c-inspect",
    get askLay() { return tt("a.74bf19ad", "검수 신청이 접수됐는지 어떻게 확인하나요?"); },
  },
  "inspect.done-not-whitelist": {
    get title() { return tt("a.2c35ef48", "검수 승인"); },
    get body() { return tt("a.1155ad2a", "화이트리스트 완료와는 다릅니다. 처리 여부는 상세 창의 화이트리스트 칸에서, 채널마다 처리하는 작품은 홈 작품 카드의 배지에서 확인하세요."); },
    guideSlug: "c-inspect",
    get askLay() { return tt("a.f33eb05f", "검수 승인인데 화이트리스트는 아직인가요?"); },
  },
  "inspect.detail-buttons": {
    get title() { return tt("a.32640d27", "버튼 안내"); },
    get body() { return tt("a.blk.hint.detail", "「저장」은 주소·파일만 바꾸고 검수 상태는 그대로입니다. 「고쳤어요, 다시 검수 받기」를 누르면 검수 승인 상태가 되돌아갑니다. 유튜브 차단은 검수 목록 「승인」 칸의 「차단 알리기」로 알립니다."); },
    guideSlug: "c-inspect",
    get askLay() { return tt("a.1f28938c", "검수 상세의 저장과 「고쳤어요, 다시 검수 받기」는 뭐가 다른가요?"); },
  },
  "inspect.resubmit": {
    get title() { return tt("a.e6d84209", "고쳤어요, 다시 검수 받기"); },
    get body() { return tt("a.68a8cc3f", "링크만 바꾸면 자동으로 재검수되지 않습니다. 이 버튼을 눌러야 상태가 바뀝니다."); },
    guideSlug: "c-inspect",
    get askLay() { return tt("a.b73755ea", "영상을 고쳤는데 다시 검수 받으려면 어떻게 하나요?"); },
  },
  // 2026-10-28 가이드라인 업데이트 — 문장은 c-works 「가이드가 바뀌면」 · c-guideline 「가이드라인이 바뀌면」과 같은 뜻
  "work.guide-update": {
    get title() { return tt("a.d844a9f4", "가이드라인 업데이트"); },
    get body() { return tt("a.57a5b874", "운영팀이 가이드를 바꾸면 바뀐 항목에 「바뀜」, 작품 관련 가이드에 새로 생긴 줄에는 「새로」가 붙어요. 「바뀐 점 확인했어요」를 누르면 표시가 사라지고, 바뀐 내용은 이 뒤에 올리는 영상부터 지키면 돼요."); },
    guideSlug: "c-works",
    get askLay() { return tt("a.d950e4a8", "작품 가이드라인이 바뀌면 무엇을 해야 하나요?"); },
  },
  "work.share-ratio": {
    get title() { return tt("a.3a4d9ef9", "배분율"); },
    get body() { return tt("a.29f14278", "적힌 비율은 크리에이터가 받는 몫입니다."); },
    guideSlug: "c-works",
    get askLay() { return tt("a.986b3f01", "작품의 배분율은 누가 받는 몫인가요?"); },
  },
  "work.download-timing": {
    get title() { return tt("a.612ca27b", "다운로드"); },
    get body() { return tt("a.aefd8b77", "아직 방영·공개되지 않은 회차의 소재는 방영 뒤에 올라옵니다. 링크가 비어 있으면 「레이에게 묻기」로 알려 주세요."); },
    guideSlug: "c-works",
    get askLay() { return tt("a.671531be", "작품 소재 다운로드 링크가 비어 있어요."); },
  },
  "work.shopping-zero": {
    get title() { return tt("a.5d52b2f4", "쇼핑 0%"); },
    get body() { return tt("a.c123049a", "이 작품 영상에는 쇼핑태그를 붙일 수 없습니다."); },
    guideSlug: "c-works",
    get askLay() { return tt("a.ac7fee8c", "쇼핑 0% 는 무슨 뜻인가요?"); },
  },
  "work.required-tier": {
    get title() { return tt("a.9ee7c4e8", "필요 등급"); },
    get body() { return tt("a.75483da6", "오류가 아닙니다. 이 작품은 표시된 등급부터 신청할 수 있습니다."); },
    guideSlug: "c-works",
    get askLay() { return tt("a.f136d7bf", "필요 등급 때문에 작품 신청이 안 돼요."); },
  },
  // ── 형식 고르기·식별코드 v2·검수 없음·화이트리스트 (2026-09-24 대표 결정 ⑨ B·⑧ A·⑤ B — 기획 §9 표 문구 그대로)
  "work.format-choice": {
    get title() { return tt("a.e4be00ac", "형식 고르기"); },
    get body() { return tt("a.fmtboth.hintChoice", "만들 영상의 형식을 골라 주세요 — 숏폼은 세로형·3분 이하, 롱폼은 가로형(길이 제한 없음)이고, 둘 다 고를 수도 있어요. 고른 형식의 코드와 배분율이 아래에 보여요. 배분율은 올린 영상의 길이로 정해져요 — 180초까지는 숏폼, 넘으면 롱폼 비율이에요. 승인된 뒤 형식을 늘리거나 바꾸면 다시 승인을 받아요."); }, // 2026-09-26 「둘 다」
    guideSlug: "c-works",
    get askLay() { return tt("a.7b5b6128", "숏폼과 롱폼 중 어떤 형식을 골라야 하나요?"); },
  },
  "work.code-format": {
    get title() { return tt("a.f9cd9cb4", "형식별 식별코드"); },
    get body() { return tt("a.0d67526d", "영상 제목이나 설명에 이 코드를 넣어 주세요. 형식별 코드가 있는 작품은 셋째 글자가 S(숏폼)·L(롱폼)로 다르고, 없는 작품은 숏폼·롱폼 모두 같은 코드를 넣어요. 배분율은 코드가 아니라 올린 영상의 길이로 정해져요 — 180초까지는 숏폼, 넘으면 롱폼 비율이에요."); },
    guideSlug: "c-upload",
    get askLay() { return tt("a.8485da93", "롱폼과 숏폼에 넣는 식별코드가 다른가요?"); },
  },
  "work.code-anatomy": {
    // v2 코드(제공사 2·형식 1·고유 2)에만 붙인다 — 기존 5자 무작위 코드에는 이 설명이 맞지 않는다
    get title() { return tt("a.d8e52348", "식별코드 읽는 법"); },
    get body() { return tt("a.57a06f32", "앞 두 글자는 제공사, 셋째 글자는 형식(S 숏폼 · L 롱폼), 마지막 두 글자는 고유 번호예요."); },
    guideSlug: "c-upload",
    get askLay() { return tt("a.7ac57793", "식별코드 다섯 글자는 각각 무슨 뜻인가요?"); },
  },
  "work.no-inspection": {
    get title() { return tt("a.bfe0909e", "검수 없음 · 사후 삭제"); },
    get body() { return tt("a.b4bdf57a", "미리 검수하지 않는 작품이에요. 그만큼 올린 뒤 권리사 요청이 오면 기한(24시간 이상) 안에 내려야 해요. 요청은 앱 알림·카카오톡으로 와요."); },
    guideSlug: "c-inspect",
    get askLay() { return tt("a.d7bfb876", "검수 없는 작품은 올린 뒤 어떻게 되나요?"); },
  },
  "work.whitelist-provided": {
    get title() { return tt("a.57768e93", "화이트리스트 제공"); },
    get body() { return tt("a.3b307107", "승인된 채널에 올린 이 작품 영상은 저작권 신고 대상이 아니에요(유튜브). 승인받지 않은 채널은 보호받지 않아요."); },
    guideSlug: "c-upload",
    get askLay() { return tt("a.21c2d633", "화이트리스트가 제공되는 작품은 무슨 뜻인가요?"); },
  },
  "work.longform": {
    get title() { return tt("a.436db8c8", "롱폼"); },
    // 형식 정의(2026-09-24 기획 coupang-direct-format-code-plan §2) — 숏폼 = 세로형·3분 이하 · 롱폼 = 가로형.
    // 2026-09-25 정정: 배분율은 영상 길이(180초) 기준 — 코드 기준 정산은 구현 전이라 「코드 기준」이라고 말하지 않는다
    get body() { return tt("a.fmt.hintLongformBody", "롱폼(가로형) 제작이 허용된 작품이에요. 스위치를 켜면 이런 작품만 보여요. 숏폼은 세로형·3분 이하예요. 배분율은 올린 영상의 길이로 정해져요 — 180초까지는 숏폼, 넘으면 롱폼 비율이에요."); },
    guideSlug: "c-works",
    get askLay() { return tt("a.4b78ae1b", "이 작품으로 롱폼을 만들어도 되나요?"); },
  },
  "promo.deadline": {
    get title() { return tt("a.296db94e", "기한"); },
    get body() { return tt("a.b2445007", "이 날짜가 업로드 마감인지 검수 신청 마감인지는 번들마다 다릅니다. 검수에 1~2 영업일이 걸리는 것을 감안하세요."); },
    guideSlug: "c-promo",
    get askLay() { return tt("a.fa21fa1e", "번들 기한은 업로드 마감인가요, 검수 신청 마감인가요?"); },
  },
  "promo.count-field": {
    get title() { return tt("a.072af31c", "제작할 영상 개수"); },
    get body() { return tt("a.3d67af7f", "1을 넣으면 됩니다. 실제 올린 편수로 셉니다."); },
    guideSlug: "c-promo",
    get askLay() { return tt("a.ef5400fc", "제작할 영상 개수에는 뭘 적나요?"); },
  },
  "promo.url-submit": {
    get title() { return tt("a.fc824ff2", "URL 제출"); },
    get body() { return tt("a.0cfb5900", "유료·조회수형 번들만 URL을 등록합니다. 자동 집계 번들은 제출이 없습니다."); },
    guideSlug: "c-promo",
    get askLay() { return tt("a.9f1281ec", "번들 영상 URL 은 언제 제출하나요?"); },
  },
  "promo.bundle-ratio": {
    get title() { return tt("a.54f876ca", "번들 비율"); },
    get body() { return tt("a.075d508c", "회차가 아니라 쇼츠 편수 기준입니다. 한 영상은 한 번들에만 들어갑니다."); },
    guideSlug: "c-promo",
    get askLay() { return tt("a.08708873", "번들 비율은 회차 기준인가요, 편수 기준인가요?"); },
  },
  // 번들 세는 규칙 한 줄(2026-09-27 원장 v5 · 아이콘 한 줄 docs/design/bundle-copy-icons-plan.html) — 채널 홈 「진행 중 번들」 제목 아래 ⓘ.
  "promo.bundle-count": {
    get title() { return tt("a.v5ic10", "번들은 이렇게 세요"); },
    get body() { return tt("a.v5ic11", "신청해서 승인된 번들에서, 번들 기간 안에 올린 영상만 세요. 숫자는 내 채널 전체를 합친 값이고, 지운 영상은 빼고 3분 이하 쇼츠만 세요."); },
    guideSlug: "c-bundle",
    get askLay() { return tt("a.v5ic12", "번들은 어떤 영상을 세나요?"); },
  },
  // 같은 자리의 원장 v6 판(2026-10-19 · decisions.md 2026-10-19) — 원장이 version 'v6' 을 줄 때만 BundleCountRule 이 연다.
  "promo.bundle-count-v6": {
    get title() { return tt("a.v5ic10", "번들은 이렇게 세요"); },
    get body() { return tt("a.bundleV6.countBody", "신청하지 않아도 돼요. 번들 기간 안에 올린 영상을 자동으로 세요. 숫자는 내 채널 전체를 합친 값이에요. 리워드 작품은 전체 공개로 올린 순간 만든 것으로 세고, 기준 작품 영상은 비공개·삭제하면 빠져요. 번들이 끝나면 남은 편수는 사라져요. 9월 4일 뒤에 올린 기준 작품의 권한은 그 작품 인정 기간이 끝나면 먼저 사라져요."); },
    guideSlug: "c-bundle",
    get askLay() { return tt("a.v5ic12", "번들은 어떤 영상을 세나요?"); },
  },
  // 번들 나눠 담기(쇼츠마다 번들 고르기) — 기획 docs/ops/bundle-choice-help-plan.md §3-3 (2026-09-24). 가이드 c-bundle 과 같은 문장.
  "promo.bundle-choose": {
    get title() { return tt("a.a746d0db", "번들 나눠 담기"); },
    get body() { return tt("a.43aad15c", "같은 작품이 참여한 번들 두 곳에 걸리면 쇼츠마다 넣을 번들을 골라요. 한 쇼츠는 한 번들에만 들어가요."); },
    guideSlug: "c-bundle",
    get askLay() { return tt("a.dc033fea", "번들 나눠 담기는 왜 해야 하나요?"); },
  },
  "promo.bundle-deadline": {
    get title() { return tt("a.79db9c7e", "3일 안에 골라 주세요"); },
    get body() { return tt("a.405a761d", "밤 23:30 에 목록에 들어온 때부터 3일이에요. 늦게 골라도 되지만, 그때는 고른 때 올린 것으로 봐요."); },
    guideSlug: "c-bundle",
    get askLay() { return tt("a.5d411a29", "번들을 늦게 고르면 어떻게 되나요?"); },
  },
  "promo.bundle-rescue": {
    get title() { return tt("a.cfbf0452", "기한이 지난 쇼츠"); },
    get body() { return tt("a.90c63ef9", "안 고른 쇼츠도 기다리는 약속을 채울 수 있으면 레이블리가 그 번들에 넣어요(레이블리가 넣음). 제작 가능 편수를 늘리려면 직접 골라 주세요."); },
    guideSlug: "c-bundle",
    get askLay() { return tt("a.2d2cfb10", "번들을 안 고르면 어떻게 되나요?"); },
  },
  "promo.bundle-locked": {
    get title() { return tt("a.75bbc9bc", "고정"); },
    get body() { return tt("a.6afcf9f8", "약속을 지키는 데 이미 쓰인 쇼츠예요. 옮기면 끝난 약속이 다시 열려서 다른 번들로 옮길 수 없어요."); },
    guideSlug: "c-bundle",
    get askLay() { return tt("a.80d1a5f5", "고정된 쇼츠는 왜 못 옮기나요?"); },
  },
  "promo.bundle-auto": {
    get title() { return tt("a.3b8ac477", "자동(출시 전)"); },
    get body() { return tt("a.1dc54cab", "나눠 담기 기능이 생기기 전에 들어온 쇼츠예요. 기다리는 약속이 있는 번들부터 넣어 두었고, 약속에 쓰이지 않았으면 바꿀 수 있어요."); },
    guideSlug: "c-bundle",
    get askLay() { return tt("a.694f8240", "자동(출시 전)으로 들어간 쇼츠는 바꿀 수 있나요?"); },
  },
  "promo.bundle-rule": {
    get title() { return tt("a.b03c9cf2", "앞으로 묻지 말고 넣기"); },
    get body() { return tt("a.92a0d65a", "켜면 그 작품 새 쇼츠가 바로 그 번들에 들어가고, 내가 고른 것으로 쳐요. 이미 있는 쇼츠는 그대로예요."); },
    guideSlug: "c-bundle",
    get askLay() { return tt("a.d3a77668", "새 쇼츠를 자동으로 한 번들에 넣을 수 있나요?"); },
  },
  "promo.bundle-history": {
    get title() { return tt("a.78c82118", "고른 기록"); },
    get body() { return tt("a.05818e97", "언제 · 어느 쇼츠 · 어느 번들에서 어느 번들로 · 누가(나 · 운영팀 · 자동 넣기 · 레이블리)를 시간순으로 보여 줘요. 줄을 누르면 바로 바꿀 수 있어요."); },
    guideSlug: "c-bundle",
    get askLay() { return tt("a.1e7ae0eb", "내가 고른 번들 기록은 어디서 보나요?"); },
  },
  "promo.bundle-change": {
    get title() { return tt("a.13aecb19", "바꾸기"); },
    get body() { return tt("a.b8af16d3", "고른 쇼츠는 사라지지 않고 여기 남아요. 「바꾸기」를 누르면 다른 번들로 옮기거나 고른 것을 취소할 수 있어요. 약속에 쓰인 「고정」 쇼츠만 못 옮겨요."); },
    guideSlug: "c-bundle",
    get askLay() { return tt("a.dc912ad1", "고른 번들을 다른 번들로 바꿀 수 있나요?"); },
  },
  "promo.bundle-missing": {
    get title() { return tt("a.515d97e7", "제작한 쇼츠가 안 보일 때"); },
    get body() { return tt("a.502a9f49", "유튜브 주소를 넣으면 3분 넘는 영상 · 식별코드 없음 · 아직 수집 전(밤 23:30) 가운데 무엇인지 알려 드려요. 그 밖이면 운영팀 확인으로 접수돼요."); },
    guideSlug: "c-bundle",
    get askLay() { return tt("a.eb187045", "제작한 쇼츠가 목록에 안 보여요."); },
  },
  "settle.which-month": {
    get title() { return tt("a.cfaf99f1", "몇 월분 정산인가요"); },
    get body() { return tt("a.c0916228", "N월 정산은 N−2월에 발생한 수익입니다. 유튜브·네이버·카카오 모두 같습니다."); },
    guideSlug: "c-settle",
    get askLay() { return tt("a.a53008d3", "이번 정산은 몇 월에 발생한 수익인가요?"); },
  },
  "settle.button-disabled": {
    get title() { return tt("a.3f9832e6", "정산 신청 버튼"); },
    get body() { return tt("a.8ea7b232", "이 회차에 정산 금액이 없어서 눌리지 않습니다. 오류가 아닙니다."); },
    guideSlug: "c-settle",
    get askLay() { return tt("a.7fb6e763", "정산 신청 버튼이 눌리지 않아요."); },
  },
  // 2026-10-01 크리에이터 정산 세부 내역서(엑셀) — 문장은 c-settle 「세부 내역서 받기」 문단과 같은 뜻(docs/ops/creator-settlement-statement-plan.md)
  "settle.statement-download": {
    get title() { return tt("a.770ab666", "세부 내역서"); },
    get body() { return tt("a.2ced8ce9", "채널·작품·영상별로 내 몫과 비율을 엑셀로 받아요. 숫자는 이 정산 창과 같아요."); },
    guideSlug: "c-settle",
    get askLay() { return tt("a.abdbdfc6", "정산 세부 내역서는 어떻게 받나요?"); },
  },
  "settle.unsettled": {
    get title() { return tt("a.6b05bbbb", "미정산금액"); },
    get body() { return tt("a.412cc22e", "2025년 10월 정산일 통합 전, 두 일정 사이의 잔액입니다. 보류된 돈이 아닙니다."); },
    guideSlug: "c-settle",
    get askLay() { return tt("a.42ad31c7", "미정산금액은 무슨 돈인가요?"); },
  },
  "settle.register-even-if-negative": {
    get title() { return tt("a.92a1fa15", "정산 정보 등록"); },
    get body() { return tt("a.c5822bc5", "받을 돈이 없거나 마이너스여도 등록해야 정산이 완료됩니다."); },
    guideSlug: "c-settle",
    get askLay() { return tt("a.561d37b1", "받을 돈이 없어도 정산 정보를 등록해야 하나요?"); },
  },
  "revenue.receivable-only": {
    get title() { return tt("a.43b5dbea", "화면의 금액"); },
    get body() { return tt("a.dd7a10bf", "받을 금액만 보입니다. 레이블리에 낼 금액은 정산 뒤 문자로 안내됩니다. 화면 금액을 그대로 입금하지 마세요."); },
    guideSlug: "c-revenue",
    get askLay() { return tt("a.55fdfd90", "수익 화면의 금액을 그대로 입금하면 되나요?"); },
  },

  // ── 네이버 클립 수익 제출 (2026-09-22 · 시트·정산 관리 모달) — 가이드 c-settle(「네이버 클립 제출 내역 확인하기」 · 정산이 밀리는 경우의 네이버 클립 줄) — 테스트 규칙상 settle.* 는 c-settle 로 연다; 캡처 화면 상세는 c-nv-start 를 c-settle 에서 링크
  "settle.naver-capture-screen": {
    get title() { return tt("a.699e8134", "어떤 화면을 찍나요"); },
    get body() { return tt("a.nv15h01", "클립 크리에이터 앱 › 내 정보 › 수익 › 정산 완료 내역. 큰 글씨는 돈을 받은 달, 작은 글씨는 그 돈을 번 달이에요 — 8월에 번 돈은 큰 글씨 「10월」 줄(작은 글씨 2026. 8.)에 있어요. 큰 글씨 「8월」 줄은 6월에 번 돈이라 받지 않아요. 그 줄 상태가 「정산 완료」인 캡처만 받아요 — 「지급 예정」「지급 산정 중」이거나 정산 현황 요약이면 접수되지 않아요. 5만원 미만으로 이월돼 그 줄이 없으면 위쪽 「최소 수익 5만원 미만」 카드와, 월별 수익 현황에서 그 달 막대를 눌러 뜬 금액이 함께 보이게 찍어 주세요(그 달 금액 그대로 정산해요). 금액은 가리지 말고, 계좌번호 같은 다른 정보는 가려도 돼요."); },
    guideSlug: "c-settle",
    get askLay() { return tt("a.61cdbf55", "네이버 클립 수익은 어떤 화면을 캡처해서 올리나요?"); },
  },
  "settle.naver-attest": {
    get title() { return tt("a.48c5ad7b", "제출 금액 확인"); },
    get body() { return tt("a.ef0ec0f6", "올린 금액이 네이버 화면의 지급액과 같다는 확인이에요. 사실대로 올리면 아무 문제 없어요. 금액을 고의로 줄이거나 화면을 편집해 올리면 정산을 바로잡고 차액을 돌려받으며 손해배상 책임이 있을 수 있어요."); },
    guideSlug: "c-settle",
    get askLay() { return tt("a.f613fe61", "「제출 금액 확인」 동의는 무엇인가요?"); },
  },
  "settle.naver-deadline": {
    get title() { return tt("a.df233763", "마감"); },
    get body() { return tt("a.8b6f2d51", "매달 9일에 카드가 열리고(네이버가 전달 수익을 6~7일에 확정해요) 15일 자정까지 올려 주세요. 그 사이엔 아무 제한이 없고, 12일·15일에 한 번 더 알려 드려요. 16일 0시부터는 올릴 때까지 레이블리 이용이 제한되고, 늦게라도 올리면 바로 풀려요. 2026년 11월 발생 수익분(2027년 1월 정산)부터는 개정 약관에 따라 그 달 정산도 지급되지 않아요."); },
    guideSlug: "c-settle",
    get askLay() { return tt("a.4eba9bb7", "네이버 클립 수익 제출 마감은 언제인가요?"); },
  },
  "settle.naver-history": {
    get title() { return tt("a.cf8cdfbb", "네이버 클립 제출 내역"); },
    get body() { return tt("a.426268c2", "내가 올린 캡처와 제출 금액, 운영팀이 확정해 정산에 반영한 금액을 그 달 기준으로 나란히 봐요. 다르면 ⚠ 표시와 운영팀 메시지가 있어요. 확인용이라 제출·재제출은 홈의 네이버 클립 카드에서만 해요."); },
    guideSlug: "c-settle",
    get askLay() { return tt("a.e03b06c5", "네이버 클립 수익 제출 내역은 어디서 보나요?"); },
  },

  // ── 멤버십·결제 (2026-09-21) — 가이드 「멤버십 구독료 안내」(c-plan, 결제 시행일 발행). 문장은 가이드·약관 제16·20·24조와 같은 말.
  "billing.charge-day": {
    get title() { return tt("a.c5fed191", "청구일"); },
    get body() { return tt("a.f654ae2a", "매월 1일에 등급이 확정되고 10:00에 등록한 카드로 결제됩니다. 실패하면 매일 10:00에 다시 시도하고, 말일까지 결제되지 않으면 멤버십이 중단됩니다."); },
    guideSlug: "c-plan",
    get askLay() { return tt("a.1160988c", "멤버십 구독료는 언제 결제되나요?"); },
  },
  "billing.method": {
    get title() { return tt("a.8cdf4b0f", "결제수단"); },
    get body() { return tt("a.ca15cadf", "카드만 등록할 수 있습니다. 카드번호는 토스페이먼츠에만 저장되고 레이블리는 보관하지 않습니다. 증빙은 카드 매출전표입니다."); },
    guideSlug: "c-plan",
    get askLay() { return tt("a.232705b3", "결제수단은 카드만 되나요? 세금계산서는요?"); },
  },
  // 2026-09-22 대표 결정으로 뜻이 바뀌었다(접근권 → 진짜 등급). 「한 키 한 뜻」이라 키도 새로 뗐다.
  "billing.access-pass": {
    get title() { return tt("a.713a189c", "등급 승급권"); },
    get body() { return tt("a.8d1ce4ee", "사면 3개월 동안 실제로 그 등급이 됩니다(다이아몬드 100만원 · 마스터 300만원). 총 20석 한정이고, 결제 즉시 시작되며 환불되지 않습니다."); },
    guideSlug: "c-plan",
    get askLay() { return tt("a.19649da0", "등급 승급권이 뭔가요? 사면 진짜 등급이 오르나요?"); },
  },
  "billing.price-table": {
    get title() { return tt("a.97eaedfc", "등급별 월 멤버십 구독료"); },
    get body() { return tt("a.fc05909f", "멤버십 구독료는 그달 1일에 확정된 내 등급 하나로 정해지고 채널 수와는 관계없습니다. 등급이 내려가 멤버십 구독료가 오르면 동의한 뒤에만 청구됩니다."); },
    guideSlug: "c-plan",
    get askLay() { return tt("a.3802a495", "등급이 바뀌면 멤버십 구독료는 어떻게 되나요?"); },
  },
  "billing.history": {
    get title() { return tt("a.6d3881d7", "결제 내역"); },
    get body() { return tt("a.eeca32a5", "최근 12개월 결제가 보입니다. 줄을 누르면 주문번호와 내역이, 「영수증」을 누르면 카드 매출전표가 열립니다. 환불은 카드사에 따라 3~7영업일 뒤 반영됩니다."); },
    guideSlug: "c-plan",
    get askLay() { return tt("a.a3a35efe", "결제 영수증은 어디서 보나요?"); },
  },
  "billing.cancel": {
    get title() { return tt("a.2790b54c", "멤버십 해지"); },
    get body() { return tt("a.1f27d6a9", "해지해도 결제한 기간 끝까지 그대로 이용하고 그 뒤로 청구되지 않습니다. 남은 날짜만큼의 환불은 없고, 종료 전에는 비용 없이 해지를 취소할 수 있습니다."); },
    guideSlug: "c-plan",
    get askLay() { return tt("a.2371f967", "멤버십을 해지하면 언제까지 쓸 수 있나요?"); },
  },
  "billing.signup-coverage": {
    get title() { return tt("a.5734eaa6", "가입비에 포함된 기간"); },
    get body() { return tt("a.b2a015b5", "가입비에는 결제일부터 한 달 동안의 이용이 들어 있습니다. 그달 남은 날은 그달 등급 멤버십 구독료를 날짜만큼만, 다음 달 1일부터 월 멤버십 구독료가 청구됩니다."); },
    guideSlug: "c-plan",
    get askLay() { return tt("a.02f748b4", "가입비를 냈는데 그달 멤버십 구독료가 또 나가나요?"); },
  },
  "billing.refund-7days": {
    get title() { return tt("a.8baf94b0", "7일 환불"); },
    get body() { return tt("a.ed46ba4c", "결제일을 포함해 7일 안이고 결제 뒤 승인된 작품·소재 다운로드·검수 신청이 없으면 전액 환불됩니다. 멤버십 해지 화면에서 조건이 맞을 때만 환불 상자가 보입니다."); },
    guideSlug: "c-plan",
    get askLay() { return tt("a.3ec367a7", "결제한 뒤 환불은 언제 되나요?"); },
  },
};

/** id → 도움말. 모르는 id 는 null (fail-open — 화면은 ⓘ 없이 그대로 그린다) */
export function getGuideHint(id) {
  const h = id ? GUIDE_HINTS[id] : null;
  if (!h) return null;
  return {
    id,
    title: h.title,
    body: h.body,
    guideSlug: h.guideSlug,
    guideAnchor: h.guideAnchor || null,
    guideUrl: guideUrl(h.guideSlug) + (h.guideAnchor ? `#${h.guideAnchor}` : ""),
    askLay: h.askLay || null,
  };
}

/** 테스트·문서용 — 등록된 id 목록 */
export function guideHintIds() {
  return Object.keys(GUIDE_HINTS);
}
